import { useEffect, useMemo, useState } from 'react';
import api from '../api';

function clampInt(value, min, max, fallback) {
  const n = parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(Math.max(n, min), max);
}

export default function AdminLurker2Assignments() {
  const [error, setError] = useState('');

  const [q, setQ] = useState('');
  const [windowKey, setWindowKey] = useState('');
  const [assignedLogin, setAssignedLogin] = useState('');
  const [viewerUserId, setViewerUserId] = useState('');
  const [assignedUserId, setAssignedUserId] = useState('');

  const [limit, setLimit] = useState(200);
  const [page, setPage] = useState(0);
  const offset = page * limit;

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const maxPage = useMemo(() => {
    if (!total) return 0;
    return Math.max(0, Math.ceil(total / limit) - 1);
  }, [total, limit]);

  const load = async () => {
    setError('');
    const params = {
      limit,
      offset,
      ...(q.trim() ? { q: q.trim() } : {}),
      ...(windowKey.trim() ? { windowKey: windowKey.trim() } : {}),
      ...(assignedLogin.trim() ? { assignedLogin: assignedLogin.trim() } : {}),
      ...(viewerUserId.trim() ? { viewerUserId: viewerUserId.trim() } : {}),
      ...(assignedUserId.trim() ? { assignedUserId: assignedUserId.trim() } : {}),
    };
    const { data } = await api.get('/admin/lurker2-assignments', { params });
    setItems(Array.isArray(data.items) ? data.items : []);
    setTotal(Number(data.total || 0));
  };

  const downloadCsv = async () => {
    setError('');
    try {
      const params = {
        limit,
        offset,
        format: 'csv',
        ...(q.trim() ? { q: q.trim() } : {}),
        ...(windowKey.trim() ? { windowKey: windowKey.trim() } : {}),
        ...(assignedLogin.trim() ? { assignedLogin: assignedLogin.trim() } : {}),
        ...(viewerUserId.trim() ? { viewerUserId: viewerUserId.trim() } : {}),
        ...(assignedUserId.trim() ? { assignedUserId: assignedUserId.trim() } : {}),
      };

      const res = await api.get('/admin/lurker2-assignments', { params, responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
      a.download = `lurker2-assignments-${stamp}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || 'CSV Download fehlgeschlagen');
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await load();
      } catch (e) {
        setError(e?.response?.data?.error || e?.message || 'Konnte Zuteilungen nicht laden');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, offset, q, windowKey, assignedLogin, viewerUserId, assignedUserId]);

  const fmt = (v) => {
    if (!v) return '';
    try {
      return new Date(v).toLocaleString();
    } catch {
      return String(v);
    }
  };

  return (
    <div className="home-page">
      <section style={{ width: '100vw', margin: 0, padding: 0, position: 'relative', left: '-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin: '0 0 8px' }}>Lurker2 – Zuteilungen</h2>
        <p className="hero-desc" style={{ margin: '0 auto 24px', textAlign: 'center', maxWidth: 860 }}>
          Übersicht über gespeicherte Lurker2-Zuteilungen (pro User/Window). Filter & Paging sind serverseitig.
        </p>
      </section>

      <section style={{ width: '100%', maxWidth: 1300, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {error && <div style={{ color: 'tomato', marginBottom: 10 }}>{error}</div>}

        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 12, marginBottom: 12 }}>
          <h3 style={{ marginTop: 0 }}>Filter</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 10, alignItems: 'end' }}>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>Suche (q)</div>
              <input value={q} onChange={(e) => { setPage(0); setQ(e.target.value); }} placeholder="login / windowKey / userId" />
            </label>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>WindowKey</div>
              <input value={windowKey} onChange={(e) => { setPage(0); setWindowKey(e.target.value); }} placeholder="#" />
            </label>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>Assigned Login</div>
              <input value={assignedLogin} onChange={(e) => { setPage(0); setAssignedLogin(e.target.value); }} placeholder="twitch login" />
            </label>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>ViewerUserId</div>
              <input value={viewerUserId} onChange={(e) => { setPage(0); setViewerUserId(e.target.value); }} placeholder="#" />
            </label>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>AssignedUserId</div>
              <input value={assignedUserId} onChange={(e) => { setPage(0); setAssignedUserId(e.target.value); }} placeholder="#" />
            </label>
            <label>
              <div style={{ fontSize: 12, color: '#bbb' }}>Limit</div>
              <select value={limit} onChange={(e) => { setPage(0); setLimit(clampInt(e.target.value, 10, 1000, 200)); }}>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
              </select>
            </label>

            <div style={{ gridColumn: '1 / span 6', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => load().catch(() => {})}>Aktualisieren</button>
              <button onClick={() => downloadCsv().catch(() => {})}>CSV</button>
              <button onClick={() => {
                setPage(0);
                setQ('');
                setWindowKey('');
                setAssignedLogin('');
                setViewerUserId('');
                setAssignedUserId('');
              }}>Reset</button>
            </div>
          </div>
        </div>

        <div style={{ fontSize: 12, color: '#bbb', marginBottom: 8 }}>
          {total ? `Gesamt: ${total} · Seite ${page + 1} / ${maxPage + 1}` : 'Keine Einträge'}
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <button onClick={() => setPage(p => Math.max(0, p - 1))} disabled={page <= 0}>Zurück</button>
          <button onClick={() => setPage(p => Math.min(maxPage, p + 1))} disabled={page >= maxPage}>Weiter</button>
        </div>

        <div style={{ overflowX: 'auto', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 1100 }}>
            <thead>
              <tr style={{ background: 'rgba(255,255,255,0.04)' }}>
                <th style={{ textAlign: 'left', padding: '10px 10px' }}>Zeit</th>
                <th style={{ textAlign: 'left', padding: '10px 10px' }}>Window</th>
                <th style={{ textAlign: 'left', padding: '10px 10px' }}>Viewer</th>
                <th style={{ textAlign: 'left', padding: '10px 10px' }}>Assigned</th>
                <th style={{ textAlign: 'left', padding: '10px 10px' }}>Login</th>
                <th style={{ textAlign: 'right', padding: '10px 10px' }}>Viewer</th>
                <th style={{ textAlign: 'right', padding: '10px 10px' }}>Need</th>
                <th style={{ textAlign: 'center', padding: '10px 10px' }}>Planned</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => {
                const viewer = it.viewerUser;
                const assigned = it.assignedUser;
                const login = String(it.assignedLogin || '');
                return (
                  <tr key={it.id} style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                    <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>
                      <div title={`Expires: ${fmt(it.expiresAt)}`}>{fmt(it.assignedAt)}</div>
                    </td>
                    <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>{it.windowKey}</td>
                    <td style={{ padding: '8px 10px' }}>
                      {viewer ? (
                        <a href={`/u/${viewer.id}`} style={{ color: '#bfe3ff' }}>
                          {viewer.displayName || viewer.username} (#{viewer.id})
                        </a>
                      ) : (
                        <span>#{it.viewerUserId}</span>
                      )}
                    </td>
                    <td style={{ padding: '8px 10px' }}>
                      {assigned ? (
                        <a href={`/u/${assigned.id}`} style={{ color: '#bfe3ff' }}>
                          {assigned.displayName || assigned.username} (#{assigned.id})
                        </a>
                      ) : (
                        <span>#{it.assignedUserId}</span>
                      )}
                    </td>
                    <td style={{ padding: '8px 10px' }}>
                      {login ? (
                        <a href={`https://twitch.tv/${encodeURIComponent(login)}`} target="_blank" rel="noreferrer" style={{ color: '#bfe3ff' }}>
                          {login}
                        </a>
                      ) : (
                        <span />
                      )}
                    </td>
                    <td style={{ padding: '8px 10px', textAlign: 'right' }}>{Number(it.viewerCount || 0)}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'right' }}>{typeof it.needScore === 'number' ? it.needScore.toFixed(3) : ''}</td>
                    <td style={{ padding: '8px 10px', textAlign: 'center' }}>{it.planned ? 'ja' : ''}</td>
                  </tr>
                );
              })}
              {!items.length && (
                <tr>
                  <td colSpan={8} style={{ padding: '12px 10px', color: '#bbb' }}>Keine Einträge.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
